import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class SimpleSearch extends Component {
  static defaultProps = {
    className: '',
    false: true,
  };

  static propTypes = {
    placeholder: PropTypes.string.isRequired,
    searchQuery: PropTypes.string.isRequired,
    handleSearchQueryChange: PropTypes.func.isRequired,
    handleSearch: PropTypes.func.isRequired,
    handleSearchEnterPress: PropTypes.func.isRequired,
    className: PropTypes.string,
    renderSearchButton: PropTypes.bool,
  };

  render() {
    const {
      placeholder,
      searchQuery,
      handleSearch,
      handleSearchEnterPress,
      handleSearchQueryChange,
      className,
      renderSearchButton,
      children,
    } = this.props;
    return (
      // <div className={classNames('themes-search', className)}>
      <React.Fragment>
        <div className="search-block themes-search__input">
          <input
            type="text"
            className="search-block__input"
            placeholder={placeholder}
            value={searchQuery}
            onChange={e => handleSearchQueryChange(e)}
            onKeyDown={e => handleSearchEnterPress(e)}
          />
          <button type="submit" className="search-block__button" onClick={handleSearch}>
            Поиск
          </button>
        </div>
        {renderSearchButton && (
          <button
            className="btn -secondary themes-search__button themes-search__button--search"
            onClick={handleSearch}
          >
            Поиск
          </button>
        )}
        {children}
        </React.Fragment>
      // </div>
    );
  }
}
